import axios from "../utils/axios";

export const getAllEquipmentsByArea = (payload) => {
    return axios.get(`/Equipment/GetHierarchy?areaId=${payload}`);
};

export const createMultiplePM = (payload) => {
    return axios.post(`/PlannedMaintenance/CreateMultipleOrders`, payload);
};